import DefaultPaletteOptions from '../defaultPallete';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (theme: DefaultPaletteOptions): any => {
  return {
    styleOverrides: {
      root: {
        minWidth: 'unset !important',
        minHeight: '56px',
        fontSize: '16px',
        color: 'unset !important',
        '& .MuiInputBase-input': {
          fontSize: '16px',
          color: theme.common?.black,
        },
        '& .Mui-focused': {
          color: '#767676',
        },
      },
    },
  };
};
